import React from "react";
import "./ItineraryCard.css";
import car from "../images/Car.png";
import hotel from "../images/Hotel.png";

const ItineraryCard = ({
  day,
  route,
  title,
  description,
  points,
  images,
  stay,
  isLast   // ✅ add this
}) => {
  return (
    <div className="itinerary-wrapper">
      
      {/* Header */}
      <div className="itinerary-header">
        <span className="day-badge">DAY {day}</span>
        <h3 className="route">{route}</h3>
      </div>

      {/* Card */}
      <div className="itinerary-card">

        {/* LEFT: Images */}
        <div className={`image-section ${images.length > 1 ? "multiple" : ""}`}>
          {images.map((img, index) => (
            <img key={index} src={img} alt="" />
          ))}
        </div>

        {/* RIGHT: Content */}
        <div className="content-section">
          <h4>{title}</h4>
          <p>{description}</p>

          {points && (
            <ul>
              {points.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
          )}

          {stay && (
            <div className="stay">
  {isLast ? (
    <><img src={car} alt="Car Icon"/> Drop-off at your station or airport</>
  ) : (
    <><img src={hotel} alt= "Hotel Icon"/> Overnight stay at {stay}</>
  )}
</div>
          )}
        </div>

      </div>
    </div>
  );
};

export default ItineraryCard;